import ajax from '@/logic/ajax-model';

export default {

  get(id) {
    return ajax.get({
      url: 'content/project/getItem',
      params: {
        id,
      },
    });
  },

  getViewToken(fileId) {
    return ajax.get({
      url: 'content/public_module/getBimfaceViewToken',
      params: {
        file_id: fileId,
      },
    });
  }
};


// WEBPACK FOOTER //
// ./src/pages/project/api.js